import { siteNav } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20warm%20rose%20and%20coral%20gradient%20background%20with%20soft%20flowing%20curves%2C%20minimalist%20geometric%20shapes%2C%20romantic%20atmosphere%2C%20ethereal%20light%20particles%2C%20dreamy%20and%20elegant%20composition%2C%20subtle%20gold%20accents%2C%20modern%20clean%20design%2C%20luxurious%20feel%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=hero-aiqingdao-01&orientation=landscape"
        alt="爱情岛网址导航"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-sm text-background-50">网址已更新 · 2024年12月</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight font-heading">
            爱情岛网址
            <br />
            最新官方入口
          </h1>

          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            找不到爱情岛网址？本页提供最新官方入口及备用访问地址，帮助您快速、安全地访问爱情岛平台全部内容
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href={siteNav.officialUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30 hover:shadow-primary-500/50"
            >
              <i className="ri-external-link-line mr-2"></i>
              访问官方入口
            </a>
            <a
              href="#quick-access"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-semibold text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-links-line mr-2"></i>
              查看备用地址
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 text-sm text-background-200/70">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i>
              官方认证
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line"></i>
              实时更新
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-lock-line"></i>
              HTTPS加密
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}